export default __webpack_public_path__ + "static/media/invalid-network.e66fb18e.png";